/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import mockData from "./inputs.json"

const useWriteMockedPlayerInputs = (playlistKey) => {

    const {signedInUser} = useContext(FirebaseAuthContext);

    // Retrieving the already existing course
    const writePlayerInputs = async () => {
        const idToken = await signedInUser.getIdToken()

        // For each prepared/mocked player input, post data data to the FB RTDB
        mockData.inputs.forEach((inputEntry) => {
            // Results in 5 fields: scored scene, course, playlist, user, score inputs
            const fields = inputEntry.split("&")

            const playerInputData = {
                scoredSceneId: fields[0],
                courseId: fields[1],
                playlistId: fields[2],
                userId: fields[3],
                playerInputs: fields[4]?.split(";").map((scoreString) => {
                    const score = scoreString.split("|")
                    return {
                        athlete: score[0],
                        points: score[2],
                        time: Math.round((Number.parseFloat(score[1]) + Number.EPSILON) * 1000) / 1000
                    }
                }) || null,
                clientInfo: null
            }

            fetch('/reg-main/statistics', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    idToken: idToken,
                    playerInputData: playerInputData
                })
            }).then((response) => {
                console.log(response.status)
            })
        })
    }

    return {
        writePlayerInputs
    }
}
export default useWriteMockedPlayerInputs;